import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { LOGIN } from "../../../../enums/ApiPaths";
import { TERMS } from "../../../../enums/UrlPaths";
import LanguageSwitcher from "../../../../components/LanguageSwitcher";

export default function TermsLoginAndLanguageFooter() {
  const { t } = useTranslation();

  return (
    <Stack
      sx={{ mt: 4 }}
      spacing={2}
      justifyContent={"space-around"}
      alignItems={"center"}
    >
      {/* Already Have an Account? Link */}
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        {t("AlreadyHaveAnAccount?")}{" "}
        <Link to={LOGIN} style={{ color: "#1976d2", fontWeight: 500 }}>
          {t("LogIn")}
        </Link>
      </Typography>

      {/* Terms of Service Link */}
      <Typography variant="body2" color="text.secondary">
        <Link to={TERMS} style={{ color: "#1976d2", fontWeight: 500 }}>
          {t("TOS")}
        </Link>
      </Typography>

      {/* Language Switcher */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <LanguageSwitcher />
      </Box>
    </Stack>
  );
}
